const pageNameKey = "infoButton";

export const infoButtonEn = {
  [pageNameKey]: {
    infoText: "Info",
  },
};

export const infoButtonPtBr = {
  [pageNameKey]: {
    infoText: "Informações",
  },
};

export const infoButtonDe = {
  [pageNameKey]: {
    infoText: "Info",
  },
};

export const infoButtonZhHans = {
  [pageNameKey]: {
    infoText: "信息",
  },
};

export const infoButtonIt = {
  [pageNameKey]: {
    infoText: "Informazioni",
  },
};

export const infoButtonEs = {
  [pageNameKey]: {
    infoText: "Información",
  },
};

export const infoButtonNl = {
  [pageNameKey]: {
    infoText: "Info",
  },
};

export const infoButtonTr = {
  [pageNameKey]: {
    infoText: "Bilgi",
  },
};
